import { render, staticRenderFns } from "./MesaNewComandas.vue?vue&type=template&id=633cf25a&scoped=true"
import script from "./MesaNewComandas.vue?vue&type=script&lang=js"
export * from "./MesaNewComandas.vue?vue&type=script&lang=js"
import style0 from "./MesaNewComandas.vue?vue&type=style&index=0&id=633cf25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cf25a",
  null
  
)

export default component.exports